
import Vue from 'vue';

import MixinCriteria from '@/assets/mixins/MixinCriteria';
Vue.mixin(MixinCriteria);

import MixinUserUtil from '@/assets/mixins/MixinUserUtil';
Vue.mixin(MixinUserUtil);

import DateFormatUtil from '@/assets/mixins/DateFormatUtil';
Vue.mixin(DateFormatUtil);

import TicketFormSupport from '@/assets/mixins/TicketFormSupport';
Vue.mixin(TicketFormSupport);

import MixinTicketEventUtil from '@/assets/mixins/MixinTicketEventUtil';
Vue.mixin(MixinTicketEventUtil);

import AbstractComponent from '@/assets/mixins/AbstractComponent';
Vue.mixin(AbstractComponent);


// WEBPACK FOOTER //
// ./src/mixin.js